export default __webpack_public_path__ + "static/CourierExpresslogo_600px-6774d3fc3d0052ba756fd1a8dbdb5901.png";